var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'tag',
    _vm.type
  ]},[_c('span',{staticClass:"text",domProps:{"textContent":_vm._s(_vm.text)}}),(_vm.closable)?_c('TfButton',{staticClass:"close-btn",attrs:{"type":"secondary","icon":"times","size":"icon-no-fill"},on:{"click":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }